import React, { useState } from 'react';
import DefaultIMG from "../../../../../assets/img/HBL_logo.webp";

import { 
  Character
} from "@dndModels";

import CharacterImageInput from "@dndComponents/character/misc/CharacterImageInput";
import ModalOrDrawer from "@components/display/ModalOrDrawer";

interface Props {
  character: Character;
  disabled: boolean;
}

export default function CharacterImageButton({
  character,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
        }}>
        { open &&
          <CharacterImageInput
            character={character}
          />
        }
      </ModalOrDrawer>
    );
  }

  return (
    <>
      <div className="centered" style={{ 
          float: "left",
          width: "5em",
          height: "5em" 
        }}>
        <img src={ character.image_url === "" ? DefaultIMG : character.image_url } alt="logo" 
          style={{
            maxWidth: "5em",
            maxHeight: "5em",
            border: "1px solid",
          }} className="clickable" 
          onClick={() => {
            if (!disabled) {
              setOpen(true);
            }
          }}
        />
      </div>
      { renderExtras() }
    </>
  ); 
}

